import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { axiosBeelineRequest } from '@beef/utils';
import { getTransactionState, setTransactionState } from "../../../transaction";
import { getRequestIds } from "../../../transaction/utils";
export var sbpPaymentRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var to, amount, bindingId, _ref$createBinding, createBinding, smsCode, smsData, _yield$axiosBeelineRe, data, responseStatus, _ref3, status, payId, qrCode, verificationId, externalId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          to = _ref.to, amount = _ref.amount, bindingId = _ref.bindingId, _ref$createBinding = _ref.createBinding, createBinding = _ref$createBinding === void 0 ? false : _ref$createBinding, smsCode = _ref.smsCode;
          smsData = getTransactionState();
          _context.next = 4;
          return axiosBeelineRequest({
            method: 'post',
            url: '/sbpapi/payment/',
            originalResponse: true,
            data: _objectSpread({
              amount: amount,
              ctn: to,
              bindingId: bindingId,
              createBinding: createBinding,
              smsCode: smsCode
            }, getRequestIds(smsData, typeof smsCode === 'number'))
          });
        case 4:
          _yield$axiosBeelineRe = _context.sent;
          data = _yield$axiosBeelineRe.data;
          responseStatus = _yield$axiosBeelineRe.status;
          _ref3 = data !== null && data !== void 0 ? data : {}, status = _ref3.status, payId = _ref3.payId, qrCode = _ref3.qrCode, verificationId = _ref3.verificationId, externalId = _ref3.externalId;
          if (!(responseStatus !== 200 && !status)) {
            _context.next = 10;
            break;
          }
          throw new Error('unsuccessful response');
        case 10:
          _context.next = 12;
          return setTransactionState({
            verificationId: verificationId,
            externalId: externalId
          }, status || undefined);
        case 12:
          return _context.abrupt("return", {
            payId: payId,
            qrCode: qrCode,
            status: status
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function sbpPaymentRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();